import PageLoader from '@components/PageLoader'
import React from 'react'
import {
	CardBodyCentered,
	ContentArea,
	ContentCard,
	HeroRow,
	HeroSubtitle,
	HeroTitle,
	HiddenInput,
	PageContainer,
} from './ItineraryImportPage.styles'
import FailedBody from './components/FailedBody'
import IdleBody from './components/IdleBody'
import ImportFooter from './components/ImportFooter'
import NoEventsBody from './components/NoEventsBody'
import ProcessingBody from './components/ProcessingBody'
import RateLimitBody from './components/RateLimitBody'
import StuckBody from './components/StuckBody'
import SuccessBody from './components/SuccessBody'
import { subtitleForState, titleForState } from './copy'
import { useImportController } from './useImportController'

const ItineraryImportPage: React.FC = () => {
	const ctrl = useImportController()
	const { pageState, trip, tripLoading } = ctrl

	if (tripLoading || !trip) {
		return (
			<PageContainer>
				<PageLoader label="Loading trip…" />
			</PageContainer>
		)
	}

	return (
		<PageContainer>
			<HeroRow>
				<HeroTitle>{titleForState(pageState)}</HeroTitle>
				<HeroSubtitle>{subtitleForState(pageState)}</HeroSubtitle>
			</HeroRow>

			<ContentArea>
				<ContentCard>
					{pageState === 'idle' && (
						<IdleBody
							trip={trip}
							files={ctrl.files}
							notes={ctrl.notes}
							isDragOver={ctrl.isDragOver}
							onNotesChange={ctrl.setNotes}
							onBrowse={ctrl.onBrowse}
							onRemoveFile={ctrl.onRemoveFile}
							hasValidationErrors={ctrl.hasValidationErrors}
							validationErrorCount={ctrl.validationErrorCount}
							serverValidationMessage={ctrl.serverValidationMessage}
						/>
					)}
					{pageState === 'processing' && <ProcessingBody startedAt={ctrl.processingStartedAtMs} />}
					{pageState === 'success' &&
						(ctrl.isWaitingForImportedEvents ? (
							<CardBodyCentered>
								<PageLoader label="Loading imported events…" />
							</CardBodyCentered>
						) : (
							<SuccessBody
								tripId={ctrl.tripId ?? ''}
								createdEventIds={ctrl.createdEventIds}
								events={ctrl.events}
								trip={trip}
							/>
						))}
					{pageState === 'no_events' && <NoEventsBody />}
					{pageState === 'failed' && (
						<FailedBody importId={ctrl.importId ?? '—'} reason={ctrl.errorReason} />
					)}
					{pageState === 'rate_limit' && ctrl.rateLimitSeconds != null && (
						<RateLimitBody retryAfterSeconds={ctrl.rateLimitSeconds} />
					)}
					{pageState === 'stuck' && <StuckBody />}

					<HiddenInput
						ref={ctrl.fileInputRef}
						type="file"
						multiple
						accept="application/pdf,image/png,image/jpeg,image/heic,image/webp,image/gif"
						onChange={ctrl.onInputChange}
					/>

					<ImportFooter
						pageState={pageState}
						submitDisabled={ctrl.submitDisabled}
						isPending={ctrl.isSubmitting}
						hasValidationErrors={ctrl.hasValidationErrors}
						validationErrorCount={ctrl.validationErrorCount}
						onCancel={ctrl.onBack}
						onSubmit={ctrl.onSubmit}
						onImportMore={ctrl.onReset}
						onViewTimeline={ctrl.onViewTimeline}
						onTryAgain={ctrl.onReset}
						onRetry={ctrl.onRetry}
					/>
				</ContentCard>
			</ContentArea>
		</PageContainer>
	)
}

export default ItineraryImportPage
